/* eslint-disable react/button-has-type */

import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

function Button({
  ariaDescribedBy,
  ariaLabel,
  buttonRef,
  children,
  className,
  onKeyDown,
  disabled = false,
  type = "button",
  onClick = _.noop,
  ...rest
}) {
  return (
    <button
      ref={buttonRef}
      type={type}
      className={classNames("oj-button", className, { "state-disabled": disabled })}
      disabled={disabled}
      onClick={disabled ? _.noop : onClick}
      onKeyDown={disabled ? _.noop : onKeyDown}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      {...rest}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  ariaLabel: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  buttonRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "reset", "submit"]),
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func
}

Button.displayName = "Button"

export default Button
